let startTime = null;
let endTime = null;

const startTrack = (action) => {
  console.log('[TRACK] start track', action);
  startTime = new Date();
};

const endTrack = (action) => {
  console.log('[TRACK] end track', action);
  endTime = new Date();
  let timeDiff = endTime - startTime;
  timeDiff /= 1000;
  let seconds = Math.round(timeDiff);
  console.log(`[TRACK] Time elapsed between start and end ${seconds} seconds`);
};

export const initTracker = () => {
  window.startTrack = startTrack;
  window.endTrack = endTrack;
};
